
import Vue from "vue";
import Component from "vue-class-component";

const StaticListProps = Vue.extend({
  props: {
    items: Array,
    width: Number
  }
});

@Component({})
export default class StaticList extends StaticListProps {
  get class_() {
    return ["w-" + this.width, "px-2", "py-1", "border", "rounded"];
  }
}
